import { render } from "./RegulationTable.vue?vue&type=template&id=358519c9"
import script from "./RegulationTable.vue?vue&type=script&lang=js"
export * from "./RegulationTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__